import { lpOnElementReady } from './utils.js';

( function ( $ ) {
	$.fn.lp_course_countdown = function () {
		var countdowns = this;

		for ( var i = 0; i < countdowns.length; i++ ) {
			var _countdown = $( countdowns[ i ] );
			var speed = _countdown.attr( 'data-speed' );
			var remain =
				parseInt( _countdown.attr( 'data-timestamp-remain' ) ) * 1000;
			var showtext = _countdown.attr( 'data-showtext' );
			var current_time = new Date();
			var expiryTime = current_time.getTime() + remain;
			var expiryDate = new Date( expiryTime );
			var gmt = -expiryDate.getTimezoneOffset() / 60;
			var options = {
				expiryDate: expiryDate,
				speed: speed ? speed : 500,
				gmt: parseFloat( gmt ),
				showText: showtext === 'yes' ? 1 : 0,
				localization: {
					days: lp_coming_soon_translation.days,
					hours: lp_coming_soon_translation.hours,
					minutes: lp_coming_soon_translation.minutes,
					seconds: lp_coming_soon_translation.seconds,
				},
			};
			_countdown.mbComingsoon( options );
		}
	};

	$( document ).ready( function () {
		$( '.learnpress-course-coming-soon' ).lp_course_countdown();
	} );
} )( jQuery );

function lpCountDown( el ) {
	const timeRemaining = el.dataset.timeRemaining;
	const endDate = new Date( new Date().getTime() + timeRemaining * 1000 );
	const second = 1000,
		minute = second * 60,
		hour = minute * 60,
		day = hour * 24;

	let countDown = endDate.getTime();
	let interval = setInterval( function () {
		let now = new Date().getTime();
		const distance = countDown - now;
		const seconds = Math.floor( ( distance % minute ) / second );
		const minutes = Math.floor( ( distance % hour ) / minute );
		const hours = Math.floor( ( distance % day ) / hour );
		const days = Math.floor( distance / day );

		if ( document.querySelector( '[data-day]' ) != null ) {
			document.querySelector( '[data-day]' ).innerText = String(
				days
			).padStart( 2, '0' );
		}

		if ( document.querySelector( '[data-hour]' ) != null ) {
			document.querySelector( '[data-hour]' ).innerText = String(
				hours
			).padStart( 2, '0' );
		}

		if ( document.querySelector( '[data-minute]' ) != null ) {
			document.querySelector( '[data-minute]' ).innerText = String(
				minutes
			).padStart( 2, '0' );
		}

		if ( document.querySelector( '[data-second]' ) != null ) {
			document.querySelector( '[data-second]' ).innerText = String(
				seconds
			).padStart( 2, '0' );
		}

		if ( distance < 1000 ) {
			el.style.display = 'none';
			clearInterval( interval );
			const elParent = el.closest( '.course-coming-soon-tmpl' );
			if ( elParent ) {
				elParent.style.display = 'none';

				if ( elParent.classList.contains( 'is-single' ) ) {
					window.location.reload();
				}
			}
		}
	}, second );
}

// Find and init countdown
const lp_coming_soon_countdown = () => {
	const elements = document.querySelectorAll(
		'.course-count-down:not(.loaded)'
	);
	if ( elements.length ) {
		elements.forEach( ( e ) => {
			e.classList.add( 'loaded' );
			lpCountDown( e );
		} );
	}
};

// Listen element ready
lpOnElementReady( '.course-count-down', () => {
	lp_coming_soon_countdown();
} );

document.addEventListener( 'DOMContentLoaded', function () {
	lp_coming_soon_countdown();
} );
